export default __webpack_public_path__ + "static/blob-06-0cfb8419e4a39e69a7f74277d08c3209.svg";